// Anropar backend för prisgraf. Går alltid relativt via /api/ — i prod proxas
// detta av frontend-containerns nginx, i dev av vite.config.ts proxy.
import type { HistoryResponse } from '../types/stock';

export type HistoryRange = '1m' | '3m' | '6m' | '1y' | '2y';

export async function fetchHistory(
  ticker: string,
  range: HistoryRange = '6m',
): Promise<HistoryResponse> {
  const res = await fetch(`/api/stocks/${encodeURIComponent(ticker)}/history?range=${range}`);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
  }
  return res.json();
}
